



import { queryConfigAgreement } from "@/api/agreement";
import router from "@/router";
import { defineComponent, ref, onMounted } from "@vue/composition-api";

/**
 * 隐私协议
 */
export default defineComponent({
  name: "agreement",
  setup() {
    const content = ref("");
    const type = router.currentRoute.query.type as string;

    onMounted(async () => {
      const [err, data] = await queryConfigAgreement();

      if (!err && data !== undefined) {
        content.value = data[type].content;
      }
    });

    return {
      content,
    };
  },
});
